<script setup>
import { ref, computed } from 'vue';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';
import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';
import { ATTACHMENT_TYPES } from '../constants';
import MediaExtractedContent from './MediaExtractedContent.vue';

const emit = defineEmits(['error']);
const hasError = ref(false);
const showGallery = ref(false);
const { filteredCurrentChatAttachments, attachments } = useMessageContext();

const handleError = () => {
  hasError.value = true;
  emit('error');
};

const attachment = computed(() => {
  return attachments.value[0];
});

const isReel = computed(() => {
  return attachment.value.fileType === ATTACHMENT_TYPES.IG_REEL;
});
</script>

<template>
  <div class="flex flex-col">
    <BaseBubble class="overflow-hidden p-3" data-bubble-name="video">
      <div class="flex flex-col gap-2">
        <div
          class="relative group cursor-pointer rounded-lg overflow-hidden"
          @click="showGallery = true"
        >
          <div
            v-if="isReel"
            class="absolute p-2 flex items-start justify-end right-0 pointer-events-none"
          >
            <Icon icon="i-lucide-instagram" class="text-white shadow-lg" />
          </div>
          <video
            controls
            class="rounded-lg skip-context-menu"
            :src="attachment.dataUrl"
            :class="{
              'max-w-48': isReel,
              'max-w-full': !isReel,
            }"
            @click.stop
            @error="handleError"
          />
        </div>
        <MediaExtractedContent :attachment-id="attachment.id" />
      </div>
    </BaseBubble>
    <GalleryView
      v-if="showGallery"
      v-model:show="showGallery"
      :attachment="useSnakeCase(attachment)"
      :all-attachments="filteredCurrentChatAttachments"
      @error="handleError"
      @close="() => (showGallery = false)"
    />
  </div>
</template>
